import React from "react";
import { Truck } from "lucide-react";

const MSG = "Livraison gratuite à Abidjan";

export default function AnnouncementBar() {
  const items = Array.from({ length: 10 });
  return (
    <div data-testid="announcement-bar" className="overflow-hidden bg-[#2C1A14] py-2 text-white">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((_, i) => (
          <span key={i} className="mx-6 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.15em]">
            <Truck className="h-4 w-4 text-[#E8A598]" /> {MSG}
          </span>
        ))}
      </div>
    </div>
  );
}
